import { useEffect } from 'react';
import type { EffectCallback } from './types';

export function useEffectOnce(effect: EffectCallback): void {
  useEffect(() => {
    effect();
  }, []);
}
